import { Component, OnInit, Input, Output, EventEmitter }   from '@angular/core';

import { UserService }                                      from './../../../../user.service';
import { GroupService }                                     from './../../../../group.service';
import { ProgramService }                                   from './../../../../../../shared/services/program.service';
import { User }                                             from './../../../../../../models/program/user';
import { Wave }                                             from './../../../../../../models/program/wave';
import { Group }                                            from './../../../../../../models/program/group';
import { NewAndExistingUsers }                              from '../../../../../../models/program/new-and-existing-users';
import { ExistingUser }                                     from '../../../../../../models/program/existing-user';
import { SessionDetails }                                   from '../../../../../../models/program/session-details';

@Component({
  selector: 'app-move-user-to',
  templateUrl: './move-user-to.component.html',
  styleUrls: ['./move-user-to.component.less']
})

export class MoveUserToComponent implements OnInit {
  @Input() users: ExistingUser[] = null;
  @Input() programId: number;
  @Input() sessionId?: number;
  @Input() groupId?: number;
  @Input() singleUser?: User;
  @Output() recall: EventEmitter<boolean> = new EventEmitter<boolean>();
  public move: boolean = false;
  public waves: Wave[];
  public target: number;
  public programGroups: Group[];
  public sessions: SessionDetails[];

  constructor(
    private userService: UserService,
    private programService: ProgramService,
    private groupService: GroupService
  ) { }

  ngOnInit() {
    if (this.singleUser) { this.move = true; };
    if (!this.sessionId) {
      this.getAllProgramGroups(this.programId);
    } else {
      this.getAllSessions();
    }
  }

  /**
   * Public Methods
   */

  public setTarget(target: string): void {
    let targetId: number = parseInt(target);
    this.target = targetId;
  }

  public moveUsersToSession(users: NewAndExistingUsers, targetSession: number): void {
    this.userService.addSessionUsers(this.programId, this.sessionId, this.target, users)
                    .subscribe(() => {
                      this.move = false;
                      this.recall.emit(true);
                    });
  }

  public moveUsersToGroup(users: NewAndExistingUsers, target: number): void {
    this.userService.addGroupUsers(this.programId, target, users)
                    .subscribe(() => {
                      this.move = false;
                      this.recall.emit(true);
                    });
  }

  public deleteGroupUsers(users: number[]): void {
    this.userService.deleteGroupUsers (this.programId, this.groupId, users)
                    .subscribe(() => this.recall.emit(true));
  }

  public deleteSessionUsers(users: number[]): void {
    this.userService.deleteSessionUsers (this.programId, this.sessionId, users)
                    .subscribe(() => this.recall.emit(true));
  }


  /**
   * Private Methods
   */

  private getAllProgramGroups(id: number): void {
    this.groupService.getAllGroups(id)
                     .subscribe(groups => this.programGroups = groups);
  }

  private getAllSessions(): void {
    this.programService.getProgramWithSessions(this.programId, true)
                      .subscribe((program) => {
                        if (program) {
                          this.sessions = program.sessions.filter((session) => {
                            return session.id != this.sessionId;
                          });
                          console.log('this.sessions', this.sessions)
                        }
                      });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/users/move-user-to/move-user-to.component.ts